import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { captureRecoveryLink } from './app/core/privacy/recovery-link';

captureRecoveryLink();
bootstrapApplication(App, appConfig).catch((err) => console.error(err));

// CI-CD 0
